export default __webpack_public_path__ + "static/media/credit-card.e8c1544c.svg";